import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as MultipliersActions, Selectors as MultipliersSelectors } from 'store/ducks/multipliers';

import { Access } from 'common';
import { Page, Panel, Loading, Breadcrumbs, Pagination } from 'components';

class List extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Pontos", to: "/points" },
      { name: "Campanha de Pontos", to: "" }
    ],
  };

  componentDidMount() {
    const { location, getMultipliersRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getMultipliersRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getMultipliersRequest } = this.props;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      getMultipliersRequest(queryString.parse(location.search).page);
    }
  }

  render() {
    const { breadcrumbs } = this.state;
    const { multipliers } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Campanha de Pontos</Page.Title>

        <Panel className="panel-list">
          {Access.hasPermissions("edit-multiplier") && (
            <Link to="/points/multiplier/create" className="button-add margin-bottom-20">
              Adicionar Campanha
            </Link>
          )}

          {!multipliers.data.length && multipliers.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {multipliers.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>descrição</th>
                    <th>multiplicador</th>
                    <th>inicia em</th>
                    <th>termina em</th>
                    <th>status</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!multipliers.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {multipliers.data.map((multiplier, index) => (
                    <tr key={String(multiplier.id)}>
                      <td>{multiplier.attributes.description}</td>
                      <td>{multiplier.attributes.multiplier}</td>
                      <td>{multiplier.attributes.start_at}</td>
                      <td>{multiplier.attributes.end_at}</td>
                      <td className={multiplier.attributes.status.className}>
                        {multiplier.attributes.status.label}
                      </td>
                      <td className="text-right">
                        {Access.hasPermissions("edit-multiplier") && (
                          <Link
                            to={`/points/multiplier/${multiplier.id}/edit`}
                            className="button-icon"
                          >
                            <span className="glyph glyph-eye" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={multipliers.page}
                total={multipliers.totals}
                {...this.props}
              />

            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  multipliers: {
    ...state.multipliers,
    data: MultipliersSelectors.multipliers(state.multipliers.data),
  },
});

const mapActions = dispatch => bindActionCreators(MultipliersActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
